import React from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { ScheduleFFHelpers } from '@frontend/schedule-helpers';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { CALENDAR_TRACKING_IDS } from '../../../trackingIds/calendar-tracking-ids';
import { useZoomSafeContext } from './zoom-context';

interface ZoomControlsProps {
  className?: string;
}

const trackingIds = CALENDAR_TRACKING_IDS.zoomControls;

export const ZoomControls: React.FC<ZoomControlsProps> = ({ className }) => {
  const { t } = useTranslation('schedule');
  const { zoomIn, zoomOut, canZoomIn, canZoomOut } = useZoomSafeContext();

  const { isEnabled } = ScheduleFFHelpers.useCalendarExpandCollapseFeatureFlag();

  if (!isEnabled) {
    return null;
  }

  return (
    <div className={className} css={containerStyle}>
      <Button
        variant='secondary'
        iconName='collapse-small'
        hoverLabel={t('Collapse view')}
        onClick={zoomIn}
        disabled={canZoomIn}
        trackingId={trackingIds.collapseButton}
      />
      <Button
        variant='secondary'
        iconName='expand-small'
        hoverLabel={t('Expand view')}
        onClick={zoomOut}
        disabled={canZoomOut}
        trackingId={trackingIds.expandButton}
      />
    </div>
  );
};

const containerStyle = css({
  position: 'absolute',
  bottom: theme.spacing(2),
  right: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  'button, button[aria-disabled="true"]': {
    background: theme.colors.white,
    border: `1px solid ${theme.colors.neutral20}`,
  },
});
